import {
  all,
  put,
  putResolve,
  takeEvery,
  select,
  takeLatest,
  fork,
  join,
  call,
} from 'redux-saga/effects';
import { show as showNotification } from 'circe/notifications/actions';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import * as I18n from 'circe/I18n';
import { exception } from 'circe/logger';
import {
  fetch, fetched, generate, generated, download, downloaded,
} from './actions';

import * as api from './api';

function* doFetch(action) {
  const state = yield select();

  const { shipperId, ...request } = action.payload;
  const headers = getCurrentAuthHeader(state);

  if (typeof shipperId === 'string' && shipperId !== '') {
    request.shipperId = shipperId;
  }

  try {
    const resp = yield call(api.fetchPending, request, headers);
    yield put(fetched(resp));
  } catch (error) {
    yield put(
      showNotification(
        I18n.str('unableToFetchPendingPayables', 'Unable to fetch pending payables.'),
        'error',
      ),
    );
    exception(error);
  }
}

function* doGenerate(action) {
  const state = yield select();

  const { payload } = action;
  const headers = getCurrentAuthHeader(state);

  try {
    yield call(api.generate, payload, headers);
    yield put(
      download(payload.from, payload.to, payload.shipperIds[0], payload.courierAccountId[0]),
    );
    yield put(generated());
  } catch (error) {
    exception(error);
    yield put(showNotification(I18n.str('unableToGenerate', 'Unable to generate.'), 'error'));
  }
}

function* doDownload(action) {
  const state = yield select();

  const { payload } = action;
  const headers = getCurrentAuthHeader(state);

  try {
    const resp = yield call(api.downloadPending, payload, headers);
    if (!resp) {
      throw new Error('Unable to download payable');
    }
    if (resp.startsWith('https')) yield window.open(resp);
    else yield window.open(`https://${resp}`);

    yield put(downloaded());
  } catch (error) {
    yield put(showNotification(I18n.str('unableToDownload', 'Unable to download'), 'error'));
    exception(error);
  }
}
function* watcher(context) {
  yield all([
    takeLatest(fetch().type, doFetch),
    takeLatest(generate().type, doGenerate),
    takeLatest(download().type, doDownload),
  ]);
}

export default watcher;
